// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const createGridApi = (state, action) => action.gridApi;

export default (state = getDefaultState().gridApi, action) => {

    const actionTypes = {
        [actions.CREATE_PIP_HISTORY_REPORT_AG_GRID_API]: createGridApi
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/pip-history/reducers/create-grid-api.js